import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function UstavnoPravo() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Ustavno pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Ustavno pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Ustavno pravo
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 8
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Izučavanjem predmeta Ustavno pravo studenti izučavaju
                organizaciju državne vlasti definisanje ustavnih načela i
                principa te davanje posebnog akcenta na ustavno rešenje složenih
                država. Studenti će se upoznati sa organizacijom državne vlasti
                u Crnoj Gori naročita pažnja će se posvetiti sistemu podjele
                vlasti izučavanjem svih grana vlasti pojedinačno i u vezi sa
                ostalim granama kroz izučavanje zakonodavnih i izvršnih tijela
                vlasti na nivou države kao i pravosudnog sistema njegovog pojama
                načela i njeno djelovanja u Crnoj Gori.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Sticanje znanja o funkcionisanju ustavnopravnog sistema.
                Shvatanje veza i odnosa između nacionalnog i međunarodnog prava
                u oblasti ustavnog prava. Usvajanje pojmova neophodnih za lakše
                savladavanje javnopravnih predmeta na narednim godinama studija.
                Razvijanje vještina kroz analizu i tumačenje relevantnih pravnih
                akata. Razvijanje analitičkog mišljenja i konstruktivnog
                dijaloga. Takođe nakon sto student uspješno savlada studijski
                sadržaj predmeta Ustavno pravo biće u mogućnosti da ovlada
                osnovnim pojmovima Ustavnog prava i definiše ustavnu statiku tj
                ima saznanja o pojmu i vrstama ustava uopšte i u uporednom pravu
                i ustavnu dinamiku tj. Donošenje promjenu i ostvarivanje
                ustava.Takođe da sazna tokove razvoja ustavnosti kako kod nas
                tako i u svijetu da uporedi i pravilno tumači odnos rješenja o
                ljudskim pravima slobodama i dužnostima u Ustavu Crne Gore i
                Evropskoj konvenciji kao i da usvoji znanje o manjinskim pravima
                prema Ustavu Crne Gore. Takođe da ovlada poznavanjem ustavnog
                razvoja Crne Gore i shvati osnovne principe ustavnog uređenja.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Pojam predmet i metod Ustavnog prava izvori Ustavnog prava Ustav
                ustavni zakoni zakon uredbe poslovnik ostali podzakonski akti
                odluke sudova običajno pravo pojam ustava i njegova svojstva
                pojam ustava u materijalnom smislu pojam ustava u formalnom
                smislu odnos ustava u materijalnom i ustava u formalnom smislu
                organizacija državne vlasti; Ustavno uređenje složenih država;
                Organizacija državne vlasti u Crnoj Gori; Predstavnička tijela;
                Tijela izvršne vlasti; Pravosudni sistem; Kontrola ustavnosti i
                zakonitosti; Lokalna samouprava u Crnoj Gori.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: ex katedra, diskusija, gosti
                predavači, grupni rad, samostalno učenje i seminarski rad.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>4P</td>
                    <td>Pojam predmet i metod Ustavnog prava</td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>4P</td>
                    <td>
                      Izvori Ustavnog prava Ustav ustavni zakoni zakon uredbe
                      poslovnik ostali podzakonski akti odluke sudova običajno
                      pravo
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>4P</td>
                    <td>
                      Pojam ustava i njegova svojstva pojam ustava u
                      materijalnom smislu pojam ustava u formalnom smislu odnos
                      ustava u materijalnom i ustava u formalnom smislu.
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>4P</td>
                    <td>
                      Klasifikacije ustava donošenje ustava promjena ustava
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>4P</td>
                    <td>Sistematika i sadržaj ustava</td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>Kolokvijum I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>4P</td>
                    <td>
                      Ljudska prava deklaracije o ljudskim pravima međunarodne
                      konvencije o ljudskim pravima
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>4P</td>
                    <td>Učešče građana u vršenju vlasti</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>4P</td>
                    <td>
                      Organizacija vlasti izvršna zakonodavna i sudska vlast
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>4P</td>
                    <td>Parlament vlada šef države sudovi</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>Kolokvijum II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>4P</td>
                    <td>
                      Unitarna i složena država ( konfederacija federacija )
                    </td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>4P</td>
                    <td>Regionalna država </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>4P</td>
                    <td>Lokalna samouprava u Crnoj Gori</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>4P</td>
                    <td>Ustav Crne gore</td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 4 č / 3h</td>
                            <td>Ukupno: 80 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 4 č / 3h</td>
                            <td>Nastava + završni ispit: 60 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe:</td>
                            <td>Priprema i ovjera semestra: 6 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 14 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default UstavnoPravo;
